var React = require('react');

function TrashLight (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M42.105 8.005a1 1 0 01.89 1.1L39.37 43.523A5 5 0 0134.4 48H13.6a5 5 0 01-4.973-4.477L5.005 9.105a1 1 0 011.99-.21l3.622 34.418A3 3 0 0013.6 46h20.8a3 3 0 002.982-2.687l3.623-34.418a1 1 0 011.1-.89z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 9a1 1 0 011-1h46a1 1 0 110 2H1a1 1 0 01-1-1z","key":1}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M17 2a1 1 0 00-1 1v6a1 1 0 11-2 0V3a3 3 0 013-3h14a3 3 0 013 3v6a1 1 0 11-2 0V3a1 1 0 00-1-1H17zm7 15a1 1 0 011 1v21a1 1 0 11-2 0V18a1 1 0 011-1zm9.048.001a1 1 0 01.95 1.047l-1 21a1 1 0 01-1.997-.096l1-21a1 1 0 011.047-.95zm-18.096 0a1 1 0 011.047.951l1 21a1 1 0 01-1.998.096l-1-21A1 1 0 0114.952 17z","key":2})]);
}

TrashLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = TrashLight;

TrashLight.default = TrashLight;
